import styled from 'styled-components';
import { FC, PropsWithChildren, useState } from 'react';

import { Accordion, AccordionHeader, AccordionContent } from 'ui/accordion';
import { colors, Caption, fontWeights } from 'ui/theme';
import { WithCollapsibleReadyContentTestId } from 'modules/frequencyManagement/components/optimize/Optimize.constants';
import { pxToRem } from 'utils/convert';

const StyledAccordion = styled(Accordion)`
  padding: 0;
  background: ${colors.white};
`;

const InteractiveCaptionText = styled(Caption)`
  color: ${colors.textInteractive};
  font-weight: ${fontWeights.medium};
`;

const StyledTrigger = styled(AccordionHeader)`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${pxToRem(156)} 16px;
`;

export interface WithCollapsibleReadyContentProps {
  collapsedContent: boolean;
  isEditing?: boolean;
}
export const WithCollapsibleReadyContent: FC<
  PropsWithChildren<WithCollapsibleReadyContentProps>
> = ({ children, collapsedContent = false }) => {
  const [displayContent, toggleDisplayContent] = useState(true);
  return collapsedContent ? (
    <StyledAccordion
      onValueChange={() => toggleDisplayContent((prev) => !prev)}
      defaultValue="item-1"
      data-test={WithCollapsibleReadyContentTestId}
    >
      <StyledTrigger arrowHeight={16} arrowWidth={16} arrowColor={colors.textInteractive}>
        <InteractiveCaptionText>
          {displayContent ? 'Hide audience distribution' : 'See audience distribution'}
        </InteractiveCaptionText>
      </StyledTrigger>
      <AccordionContent>{children}</AccordionContent>
    </StyledAccordion>
  ) : (
    <>{children}</>
  );
};
